/* src/components/GalleryCard.jsx
 * 全屏霜玻璃面板（Dock 模式，单页显示）
 * 2025-06-27 update — Top bar 下移适配导航
 */
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";

/**
 * props:
 *   show        Boolean         是否显示
 *   title       String          面板标题
 *   onClose     () => void      关闭回调
 *   children    ReactNode       真正的页面组件
 */
export default function GalleryCard({ show, title, onClose, children }) {
  /* 顶部导航高度（CSS 变量，可在全局改） */
  const topOffset = "calc(var(--top-nav-height, 60px) + 12px)";

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.03 }}
          transition={{ duration: 0.25 }}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(18px) saturate(160%)",
            WebkitBackdropFilter: "blur(18px) saturate(160%)",
            border: "1px solid rgba(255,255,255,0.25)",
            boxShadow: "0 12px 28px rgba(0,0,0,0.28)",
            overflow: "hidden",
          }}
        >
          {/* ✕ 关闭按钮 */}
          <button
            onClick={onClose}
            title="Close"
            style={{
              position: "absolute",
              top: topOffset,        // ← 统一向下偏移
              right: 24,
              background: "rgba(255,255,255,0.8)",
              border: "none",
              borderRadius: 8,
              padding: "6px 12px",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: "bold",
            }}
          >
            <FaTimes />
          </button>

          {/* 面板标题（可删） */}
          <h3
            style={{
              position: "absolute",
              top: `calc(${topOffset} + 2px)`,
              left: 28,
              margin: 0,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            {title}
          </h3>

          {/* 主内容区 */}
          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "auto",
              paddingTop: `calc(${topOffset} + 36px)`, /* 留标题条高度 */
            }}
          >
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
